import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { tChangeAcctModel } from '../models/tChangeAcctModel';


@Injectable({
    providedIn: 'root'
  })
  export class tChangeAcctService {

    private selected_patient_changeAcct_Source = new BehaviorSubject('');
    current_selected_patient_changeAcct = this.selected_patient_changeAcct_Source.asObservable();

    shareSelected(selectedID: string) {
      this.selected_patient_changeAcct_Source.next(selectedID);
    }



    constructor(private http: HttpClient) { }


    baseurl: string = AppSettings.BaseURI;
    readonly pathName = '/tChangeAcctModels';

    getAllData(){
      return this.http.get<tChangeAcctModel[]>(this.baseurl + this.pathName);
    }

    
    getAllActiveChangeAccount() {
      return this.http.get<tChangeAcctModel[]>(this.baseurl + this.pathName + "/getAllActiveChangeAccount");
    }

    getDataById(shopID: string, changeID: string) {
      return this.http.get<tChangeAcctModel>(this.baseurl + this.pathName + '/' + shopID + '/' + changeID);
    }

    getChangeAcctModelByID(changeID: string) {
      return this.http.get<tChangeAcctModel>(this.baseurl + this.pathName + '/GetChangeAcctModelByID/' + changeID);
    }


    addData(data: tChangeAcctModel) {
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data);
    }

    deleteData(data: tChangeAcctModel) {
      return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.shopID + '/' + data.changeID);
    }

    updateData(data: tChangeAcctModel) {
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted' + '/' + data.shopID + '/' + data.changeID, data);
    }



    // private messageSource = new BehaviorSubject('default message');
    // currentMessage = this.messageSource.asObservable();

    // private selected_mediCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCode = this.selected_mediCode_Source.asObservable();

    // private selected_mediCateCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCateCode = this.selected_mediCateCode_Source.asObservable();

    // private selected_mediName_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediName = this.selected_mediName_Source.asObservable();

    // private selected_mediNameEng_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediNameEng = this.selected_mediNameEng_Source.asObservable();

    // private selected_mediBarCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediBarCode = this.selected_mediBarCode_Source.asObservable();



    // changeMessage(systemMedicineSetting: tChangeAcctModel) {

    //   let mediCodeStr = '';
    //   let mediCateCodeStr = '';
    //   let mediNameStr = '';
    //   let mediNameEngStr = '';
    //   let mediBarCodeStr = '';

    //   if (!isNullOrUndefined(systemMedicineSetting.mediCode)) {
    //     mediCodeStr = systemMedicineSetting.mediCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediCateCode)) {
    //     mediCateCodeStr = systemMedicineSetting.mediCateCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediName)) {
    //     mediNameStr = systemMedicineSetting.mediName.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediNameEng)) {
    //     mediNameEngStr = systemMedicineSetting.mediNameEng.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediBarCode)) {
    //     mediBarCodeStr = systemMedicineSetting.mediBarCode.toString();
    //   }


    //   this.selected_mediCode_Source.next(mediCodeStr);
    //   this.selected_mediCateCode_Source.next(mediCateCodeStr);
    //   this.selected_mediName_Source.next(mediNameStr);
    //   this.selected_mediNameEng_Source.next(mediNameEngStr);
    //   this.selected_mediBarCode_Source.next(mediBarCodeStr);

    //   // this.messageSource.next(message);
    // }
  }